module.exports = __webpack_public_path__ + "static/media/right_layout_image_Car__.ec533d12.svg";